import React, { useState, useEffect } from 'react';
import CustomerLayout from '../components/CustomerLayout';
import { customerAPI } from '../lib/api';
import '../App.css';

export default function Contracts() {
    const [contracts, setContracts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetchContracts();
    }, []);

    const fetchContracts = async () => {
        setLoading(true);
        setError(null);
        try {
            const response = await customerAPI.getContracts();
            setContracts(response.data.contracts || []);
        } catch (err) {
            console.error('Error fetching contracts:', err);
            setError(err.response?.data?.error || 'Failed to load contracts');
        } finally {
            setLoading(false);
        }
    };

    const formatCurrency = (amount) => {
        return new Intl.NumberFormat('en-AU', {
            style: 'currency',
            currency: 'AUD'
        }).format(amount || 0);
    };

    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        return new Date(dateString).toLocaleDateString('en-AU');
    };

    const getStatusColor = (status) => {
        switch (status?.toLowerCase()) {
            case 'active': return '#28a745';
            case 'pending': return '#ffc107';
            case 'cancelled': return '#dc3545';
            default: return '#6c757d';
        }
    };

    return (
        <CustomerLayout>
            <div style={{ maxWidth: '1200px' }}>
                <h1 style={{ marginBottom: '10px' }}>Contracts & Services</h1>
                <p style={{ color: '#666', marginBottom: '30px' }}>View your active contracts and service agreements</p>

                {error && (
                    <div className="alert alert-error">{error}</div>
                )}

                {loading ? (
                    <div style={{ textAlign: 'center', padding: '60px' }}>
                        <div className="spinner"></div>
                        <p style={{ marginTop: '20px', color: '#666' }}>Loading contracts...</p>
                    </div>
                ) : contracts.length === 0 ? (
                    <div className="card" style={{ textAlign: 'center', padding: '60px' }}>
                        <p style={{ fontSize: '18px', color: '#666' }}>No contracts found</p>
                    </div>
                ) : (
                    <div style={{ display: 'grid', gap: '20px' }}>
                        {contracts.map((contract) => (
                            <div key={contract.contract_id} className="card">
                                <div style={{ display: 'flex', justifyContent: 'between', alignItems: 'start' }}>
                                    <div style={{ flex: 1 }}>
                                        <h3 style={{ marginBottom: '10px' }}>{contract.contract_name}</h3>
                                        {contract.description && (
                                            <p style={{ color: '#666', marginBottom: '15px' }}>{contract.description}</p>
                                        )}
                                        
                                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: '15px', marginTop: '20px' }}>
                                            <div>
                                                <div style={{ color: '#666', fontSize: '14px', marginBottom: '5px' }}>Amount</div>
                                                <strong style={{ fontSize: '18px', color: '#007bff' }}>
                                                    {formatCurrency(contract.amount)}
                                                </strong>
                                                <div style={{ fontSize: '12px', color: '#888' }}>
                                                    {contract.billing_interval}
                                                </div>
                                            </div>
                                            
                                            <div>
                                                <div style={{ color: '#666', fontSize: '14px', marginBottom: '5px' }}>Start Date</div>
                                                <strong>{formatDate(contract.start_date)}</strong>
                                            </div>

                                            {contract.end_date && (
                                                <div>
                                                    <div style={{ color: '#666', fontSize: '14px', marginBottom: '5px' }}>End Date</div>
                                                    <strong>{formatDate(contract.end_date)}</strong>
                                                </div>
                                            )}
                                            
                                            <div>
                                                <div style={{ color: '#666', fontSize: '14px', marginBottom: '5px' }}>Next Billing</div>
                                                <strong>{formatDate(contract.next_billing_date)}</strong>
                                            </div>

                                            <div>
                                                <div style={{ color: '#666', fontSize: '14px', marginBottom: '5px' }}>Status</div>
                                                <span
                                                    className="status-badge"
                                                    style={{ backgroundColor: getStatusColor(contract.status), color: 'white' }}
                                                >
                                                    {contract.status}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </CustomerLayout>
    );
}
